import React, { useState, useEffect, memo } from 'react';
import styles from './loyalty.module.scss';
import cn from 'classnames';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Modal from '@components/common/Modal';
import CustomKeyboard from '@components/common/CustomKeyboardCopy';
import { flowType } from '@utility/userInfo';
import { urlSearchParams } from '@utility/utills';
import Style from './loyaltyCopy.module.scss';
import { connect } from 'react-redux';
import { COUNTRY_CODE } from "@constants";
import { bindActionCreators } from "redux";
import LoyaltyImg from '@assets/images/loyalty.png';
import loyaltyImgLight from '@assets/images/loyaltyLight.png';
import { orderLoyaltyGetOffers, paymentLoyaltyGetOffers } from '@reducers/loyalty';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable'
import Loader from '../common/Loader/newLoaderModal';
import { setErrorPopUp } from '@reducers/notification';
import PropTypes from 'prop-types';

const LoyaltyOffers = ({
  getLoyaltyOffers,
  handleLoyaltyNotNow,
  loyaltyRes,
  loyaltyInfo,
  loyaltyType,
  handleApplyOffer,
  groupedLoyaltyOffer,
  offer,
  orderLoyaltyGetOffers,
  accountLookup,
  deleteLoyalty,
  isConfirmStageSplit,
  storeImage,
  isLandScape,
  serverAppTheme,
  loading,
  paymentLoyaltyGetOffers,
  setErrorPopUp,
  seat,
  showCheckSeat
}) => {

  const [activeIndex, setActiveIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedOffer, setSelectedOffer] = useState([]);
  const [isCoupon, setIsCoupon] = useState(false);
  const [inputs, setInputs] = useState({});
  const [isDeleteLoyalty, setIsDeleteLoyalty] = useState(false);
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [offerOrReward, setOfferOrReward] = useState('');
  const [offerSelected, setOfferSelected] = useState(false);
  const isPaymentTerminal = flowType() === 'paymentTerminal';
  const isServerApp = flowType() === 'serverApp';
  const position = JSON.parse(window.sessionStorage.getItem('position'));
  const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
  const seatsData = JSON.parse(window.sessionStorage.getItem('seat'));
  const getTheme = JSON.parse(window.sessionStorage.getItem('auth'));
  const isSuppressGuestLoyaltyRedemption = deviceInfo?.deviceGroup?.serverAppSettings?.suppressGuestLoyaltyRedemption
  const setSelectedOfferIndex = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };


  const groupedLoyaltyOffers = offer || groupedLoyaltyOffer;
  const orderLoyalty = seatsData.paymentCheck?.loyalty?.saved && !seatsData.paymentCheck?.offer;

  const loyaltyData = loyaltyRes || null;


  useEffect(() => {
    setInputs({});
    setSwipedDown(true);
  }, [isCoupon]);

  useEffect(() => {
    if (orderLoyalty) {
      const data = {
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: userInfo.id,
        countryCode: COUNTRY_CODE[getTheme?.country]?.dialCode || "1",
        employeeCard: userInfo.employeeCard,
        checkHeaderId: seatsData.id,
        seatId: position?.id,
        loyalty: {
          accountNumber: null
        },
        paymentCheck: seatsData?.paymentCheck,
        paymentChecks: seatsData?.paymentChecks
      }
      paymentLoyaltyGetOffers(data);
    }

  }, [orderLoyalty])

  const handleOfferSelection = (item, index) => {
    setSelectedOfferIndex(index);
    if (selectedOffer.some(d => d.offerId === item.offerId)) {
      setSelectedOffer([]);
    } else {
      setSelectedOffer([item]);
    }
  };


  const handleUseCoupon = () => {
    setIsCoupon(true);
  };

  const handleApplyCode = (data) => {
    const updatedData = [{
      offerId: data.couponCode,
      isCoupon: true,
    }];
    validation(inputs).then(() => {
      setIsCoupon(false);
      handleApplyOffer(updatedData);
    }).catch((error) => {
      setErrorMessage(error);
    })
  };
  const onClickBtn = (e) => {
    setErrorMessage('');
    const value = e === '{bksp}' ? { ...inputs, ['couponCode']: inputs['couponCode']?.slice(0, -1) } : { ...inputs, ['couponCode']: inputs['couponCode'] ? inputs['couponCode'].concat(e) : ''.concat(e) };
    setInputs({
      ...inputs,
      ['couponCode']: value['couponCode']
    });
  };

  const closeKeyboard = () => {
    setSwipedDown(false);
  };

  const validation = (value) => {
    let error;
    return new Promise((resolve, reject) => {
      if (value?.couponCode?.length === 0 || !value.couponCode) {
        error = 'Coupon code is required';
      }
      if (isEmpty(error)) {
        resolve();
      } else { reject(error); }
    })
  };

  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#couponCode`);
    if (element) element.blur();
  };

  useEffect(() => {
    if (loyaltyType === 3) {
      getLoyaltyOffers();
    }
  }, [loyaltyType]);

  useEffect(() => {
    if (Object.values(groupedLoyaltyOffers)?.length > 0 && groupedLoyaltyOffers.hasOwnProperty('REWARDS') && groupedLoyaltyOffers.hasOwnProperty('OFFERS')) {
      setOfferOrReward('OFFERS')
    }
  }, [groupedLoyaltyOffers])

  const getDistributedOfferReward = (offers, offerOrReward) => {
    if (!offers || offerOrReward === '') return offers;
    return offers.filter(e => e.groupName === offerOrReward);
  };

  const noOfferSelectedPopUp = () => {
    setOfferSelected(true);
  }

  const handleErrorPopUp = () => {
    setErrorPopUp({
      res: CUSTOM_MESSAGES().LOYALTY_CONTACT_SERVER,
      noErrorTxt: true,
    })
  }
  const handleClearAccount = () => {
    deleteLoyalty();
    handleLoyaltyNotNow(false);
  }
  return (
    <>
      {loading && <Loader />}
      <div style={{ color: serverAppTheme?.primary_text }} className={cn("col-12 p-0 position-relative", (loyaltyData?.guestName || loyaltyData?.displayAccountNumber) ? "h-90" : "h-95")}>
        {loyaltyType === 3 ? (
          <>
            {(loyaltyData?.guestName || loyaltyData?.displayAccountNumber) && (
              <>
                <div className="pt-3"></div>
                <div
                  className={cn(
                    "d-flex justify-content-between align-items-center mb-2 mx-0 p-2 col-12 fs_12 fw-400 rounded"
                  )}
                  style={{
                    background: serverAppTheme?.checkDetail_tabs,
                    color: serverAppTheme?.primary_text,
                    minHeight: '40px'
                  }}
                >
                  <div className="text-left">
                    {loyaltyData?.guestName && (
                      <span className="fs_16 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                        {loyaltyData.guestName}
                      </span>
                    )}
                  </div>
                  <div className="text-right">
                    {loyaltyData?.displayAccountNumber && (
                      <span className="fs_16 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                        {loyaltyData.displayAccountNumber}
                      </span>
                    )}
                  </div>
                </div>
              </>
            )}

            {
              Object.values(groupedLoyaltyOffers)?.length > 0 &&
              groupedLoyaltyOffers.hasOwnProperty("REWARDS") &&
              groupedLoyaltyOffers.hasOwnProperty("OFFERS") && (
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn w-100 my-1  btn-ripple mr-1"
                    disabled={offerOrReward !== "OFFERS"}
                  >
                    <TouchableDiv
                      className={cn(styles.divForPayment)}
                      style={{ fontSize: isServerApp ? "2rem" : "15px" }}
                      role="button"
                      tabIndex="0"
                      onClick={() => setOfferOrReward("OFFERS")}
                    >
                      {LABEL().OFFERS}
                    </TouchableDiv>
                  </button>
                  <button
                    type="button"
                    className="btn w-100 my-1  btn-ripple ml-1"
                    disabled={offerOrReward !== "REWARDS"}
                  >
                    <TouchableDiv
                      className={cn(styles.divForPayment)}
                      style={{ fontSize: isServerApp ? "2rem" : "15px" }}
                      role="button"
                      tabIndex="0"
                      onClick={() => setOfferOrReward("REWARDS")}
                    >
                      {LABEL().REWARDS}
                    </TouchableDiv>
                  </button>
                </div>
              )
            }
            <div
              className={cn('overflowY', Object.values(groupedLoyaltyOffers)?.length !== 0 && "pt-2")}
              style={{
                // height: (isSuppressGuestLoyaltyRedemption) ? "83%" : orderLoyalty ? loyaltyData ? '90%' : '94%' : "86%"
                // height: (isSuppressGuestLoyaltyRedemption) ? "83%" : loyaltyData ? (isLandScape ? (showCheckSeat() ? '70%' : '76%') : '86%') : (showCheckSeat() ? (isLandScape ? '83%' : '90%') : '86%')
                height: isSuppressGuestLoyaltyRedemption
                  ? '83%'
                  : loyaltyData
                    ? (
                      isLandScape
                        ? (showCheckSeat() ? '70%' : '76%')
                        : '86%'
                    )
                    : (
                      showCheckSeat()
                        ? (isLandScape ? '83%' : '90%')
                        : '86%'
                    )
              }}
            >
              {Object.values(groupedLoyaltyOffers)?.length === 0 &&
                <div
                  className='h-100 d-flex justify-content-center align-items-center fw-600 fs_32 text-center'
                  style={{
                    color: serverAppTheme?.primary_text
                  }}
                >
                  {LABEL().OS_NO_OFFERS}
                </div>
              }
              {Object.values(groupedLoyaltyOffers)?.length > 0 && Object.values(groupedLoyaltyOffers)?.map(({ groupName, offers }, i) => {
                return (
                  <>
                    {getDistributedOfferReward(offers, offerOrReward)?.map((item, index) => {
                      return (
                        <TouchableDiv className={cn(styles.offersBox, 'row mx-0 mb-2 p-2 col-12')} onClick={() => handleOfferSelection(item, `${i}-${index}`)} role="presentation" disabled={isSuppressGuestLoyaltyRedemption}
                          style={{ background: activeIndex === `${i}-${index}` ? serverAppTheme?.selected : serverAppTheme?.tip_tile, border: `1px solid ${serverAppTheme?.coupon_tile_border}`, color: activeIndex === `${i}-${index}` ? 'black' : serverAppTheme?.primary_text }} >
                          <div className={cn('fs-16 px-2 text-break text-left', item.imageUrl ? 'col-8' : 'col-12')}>
                            <div className="w-100 px-1 fs_16 fw-normal">{item.name}</div>
                            {item.imageUrl === null ? (item.value <= 0) ? <></> : <div className="fs_14 w-100 py-1 ">{LABEL().LS_VALUE}: {LABEL().CURRENCY_SYMBOL}{(item.value).toFixed(2)}</div> : <></>}
                            {item.description && <div className="fs-18 fw-normal py-1 text-left" id="text">{item.description}</div>}
                          </div>
                          {item.imageUrl && (
                            <div className="col-3 p-0 text-center">
                              {item.imageUrl !== null ? (item.value <= 0) ? <></> : <div className="text-center fs-16 w-100 py-1 fw-500" style={{ color: activeIndex === `${i}-${index}` ? 'black' : serverAppTheme?.coupon_points }}>{LABEL().LS_VALUE}: {LABEL().CURRENCY_SYMBOL}{(item?.value)?.toFixed(2)}</div> : <></>}
                              <img className="img-build h-auto w-100" src={item.imageUrl} alt="" style={{ borderRadius: "12px" }} />
                            </div>
                          )}
                        </TouchableDiv>
                      );
                    })}
                    {(!offers || (offers)?.length === 0) && <> <div className='d-flex text-center justify-content-center align-items-center h-100 fs-22' style={{ color: serverAppTheme?.noRecord }}>{LABEL().OS_NO_OFFERS}</div> </>}
                  </>
                );
              })}
            </div>
            {isSuppressGuestLoyaltyRedemption &&
              <div className={cn('px-0 fs_18 justify-content-center d-flex', !orderLoyalty ? 'pt-1' : 'pt-5')}>
                {CUSTOM_MESSAGES().LS_CONTACT_SERVER_FOR_OFFER.length > 50 ? `${CUSTOM_MESSAGES().LS_CONTACT_SERVER_FOR_OFFER.slice(0, 50)}...` : CUSTOM_MESSAGES().LS_CONTACT_SERVER_FOR_OFFER}
              </div>}
            {!orderLoyalty && <div className='d-flex col-12 px-0'>
              <TouchableDiv
                className={cn('col-6 pr-0 h-5 fs_28 fw-600', isLandScape ? 'pl-2'  : 'pl-0' )}
                role="button"
                tabIndex="0"
                onClick={() => { handleClearAccount(); }}
              >
                <small
                  style={{ textDecoration: 'underline', color: serverAppTheme?.NO_RECEIPT }}
                >
                  {LABEL().LS_CLEAR_ACCOUNT}
                </small>
              </TouchableDiv>
              <TouchableDiv
                className={cn('h-5 fs_28 fw-600 mb-2 col-6', isLandScape ? `pr-3  ${styles.textallgin}` : 'px-0')}
                role="button"
                tabIndex="0"
                onClick={() => { !orderLoyalty && deleteLoyalty(); orderLoyalty && handleErrorPopUp() }}
              >
                <small
                  className='pl-30'
                  style={{ textDecoration: 'underline', color: serverAppTheme?.NO_RECEIPT }}
                // className={orderLoyalty ? styles.changeAccountDisable : ''}
                >
                  {LABEL().LS_CHANGE_ACCOUNT}
                </small>
              </TouchableDiv>
            </div>}
            {Object.values(groupedLoyaltyOffers)?.length > 0 && !isSuppressGuestLoyaltyRedemption && (
              <div className={cn('col-12 px-0 d-flex justify-between', orderLoyalty ? Style.pdngbtm : 'pt-0')}>
                <div className='col-6 pl-0 pr-1 d-flex align-items-end'>
                  <TouchableButton type="button" className={cn("col-12 px-0 btn btn-ripple text-break od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color")} onClick={(event) => { event.preventDefault(); handleLoyaltyNotNow(false) }} style={{ height: '7.5vh', backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }} rippleEffect={true}><div className={cn('fs_28 fw-600')}>{LABEL().LS_SKIP_OFFER}</div></TouchableButton>
                </div>
                <div className='col-6 pl-1 pr-0 d-flex align-items-end'>
                  <TouchableButton type="button" className={cn(Style.loyalty_btn, "col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color")} onClick={(event) => { event.preventDefault(); selectedOffer.length === 0 ? noOfferSelectedPopUp() : handleApplyOffer(selectedOffer) }} style={{ height: '7.5vh' }} rippleEffect={true}><div className={cn('fs_28 fw-600')}>{LABEL().LS_USE_OFFER}</div></TouchableButton>
                </div>
              </div>
            )}
            {Object.values(groupedLoyaltyOffers)?.length > 0 && isSuppressGuestLoyaltyRedemption && (
              <div className="col-12 pl-0 pr-0 d-flex align-items-end mb-1">
                <TouchableButton type="button" className={cn(Style.loyalty_btn, "col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color")} onClick={(e) => { e.preventDefault(); handleLoyaltyNotNow(false) }} style={{ height: '7.5vh' }} rippleEffect={true}><div className={cn('fs_32 fw-600')}>{LABEL().LS_CONTINUE}</div></TouchableButton>
              </div>
            )}
            {Object.values(groupedLoyaltyOffers)?.length === 0 && (
              <div className="col-12 pl-0 pr-0 d-flex align-items-end mb-1">
                <TouchableButton
                  type="button"
                  className={cn(Style.loyalty_btn, "col-12 px-0 btn btn-ripple od-primary-btn-bg-color od-primary-btn-font-color")}
                  onClick={(event) => { event.preventDefault(); handleLoyaltyNotNow(false) }}
                  style={{ height: "7.5vh" }}
                  rippleEffect={true}
                >
                  <div className={cn("fs_32 fw-600")}>{LABEL().CONTINUE}</div>
                </TouchableButton>
              </div>
            )}
          </>

        ) : (
          <>
            <div className="align-content-start w-100 h-20 py-1">
              {(loyaltyInfo?.signUpImageUrl || loyaltyInfo?.imageUrl) ?
                <img src={loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl} alt="" className={isLandScape ? Style.loyaltyImage_2 : Style.loyaltyImage} />
                : <div className='col-12 px-0 h-100' ><img src={getTheme === '2' ? loyaltyImgLight : LoyaltyImg} alt="" style={{ width: '100%', objectFit: 'cover', height: '100%' }} /></div>}
            </div>
            <div className='mt-auto d-flex justify-content-center align-items-end col-12 px-0 h-12 position-absolute ' style={{ bottom: '0%' }}>
              {loyaltyInfo.supportsCoupon && <div className={cn('col-6 pr-1 pl-0 text-break')}><button type="button" className={cn(Style.loyalty_btn, "btn col-12 px-0 btn-ripple fs-30 fw-600")} style={{ height: '7.5vh', lineHeight: '1.2', background: serverAppTheme?.secondaryBtn }} disabled={!loyaltyInfo.supportsCoupon || isConfirmStageSplit || Number(urlSearchParams('ticketSplitTypeId')) === 3 || Number(urlSearchParams('ticketSplitTypeId')) === 2 || (seatsData.offers.length > 0 && seatsData.paymentStages.length === 0) || (seatsData.paidAmount !== 0 && seatsData.paymentStages.length === 0)} onClick={() => handleUseCoupon()} ><div className={cn('fs-30 fw-600')}>{LABEL().USE_COUPON}</div></button> </div>}
              <div className={cn(loyaltyInfo.supportsCoupon ? 'col-6 pl-1 pr-0' : 'col-12 px-0')}><button type="button" className={cn(Style.coupon_btn, "btn btn-ripple col-12 px-0 ")} style={{ height: '7.5vh', backgroundColor: serverAppTheme?.SKIP_OFFER_btn, color: serverAppTheme?.primary_text }} onClick={() => handleLoyaltyNotNow(true)}><div className={cn('fs-30 fw-600')}>{LABEL().LS_SKIP_OFFER}</div></button></div>
            </div>
          </>
        )}
        {isCoupon && (loyaltyType === 5) && (
          <Modal
            isOpen={isCoupon}
            style={{ width: '100%', height: '100%', margin: 0 }}
            customClass='h-100 m-0'
            customClass2='h-100 m-0'
          >
            <div className={cn('w-100 p-2 row mx-0 justify-content-center')}>
              <div className="align-content-start w-100 h-auto">
                {(loyaltyInfo?.signUpImageUrl || loyaltyInfo?.imageUrl) ?
                  <img src={loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl} alt="" className={styles.loyaltyImage} />
                  : <div className='col-12 h-0' >  {storeImage.imageUrl !== '' && <img src={storeImage.imageUrl} alt='strImg' style={{ width: '100%', height: 'auto' }} />}</div>}
              </div>

              <div className={cn('col-12  text-center py-3 h-40 mt-4')}>
                <div className=' fs-28 my-2'>{CUSTOM_MESSAGES().ENTER_COUPON_CODE}</div>
                <input
                  id='couponCode'
                  type="text"
                  name="couponCode"
                  className={cn('col-12 form-control')}
                  value={getInputValue('couponCode')}
                  onFocus={() => { handleBlur(); }}
                />
              </div>
              {errorMessage.length > 0 && <div className="text-center col-12 fs-12">{errorMessage}</div>}

              {isSwipedDown && (
                <div className={cn(' w-100 h-auto px-2')}>
                  <CustomKeyboard
                    onClickBtn={(e) => onClickBtn(e)}
                    type='text'
                    typed={inputs['couponCode'] || ''}
                    closeKeyboard={closeKeyboard}
                    btnSize="btn35"
                    customClass="fs-30 "
                    isPaymentApp={isPaymentTerminal}
                  />
                </div>
              )}

              <div className='row align-items-end h-9 my-2 m-0'  >
                <div className='col-6 pr-1 p-0'>
                  <TouchableButton type='submit' onClick={() => handleApplyCode(inputs)} className={cn('btn text-break fs-16 w-100 rounded  btn-ripple', Style.loyalty_btn)}>{LABEL().APPLY_CODE}</TouchableButton>
                </div>
                <div className='col-6 pl-1 p-0'>
                  <TouchableButton type='button' onClick={(event) => { event.preventDefault(); setIsCoupon(false) }} className={cn('btn fs-16 w-100 rounded  btn-ripple', Style.coupon_btn)}>{LABEL().COUPON_CANCEL}</TouchableButton>
                </div>

              </div>
            </div>
          </Modal>
        )}

        {isDeleteLoyalty && (
          <Modal
            isOpen={isDeleteLoyalty}
            isModalCenter
            customClass2={cn('h-98')}
            style={{ height: '98%', width: '480px', margin: 'auto', backgroundColor: serverAppTheme?.popUp_bg, minHeight: '222px', borderRadius: '16px', border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow }}
          >
            <div className='col-12 p-2 d-flex flex-column mx-0 fs-18 justify-content-center align-items-center ' style={{ color: serverAppTheme?.primary_text }}>
              <div className='py-2 fs-34 fw-600 text-center'>Are You Sure?</div>
              <div className='px-4 text-center my-3  fs-26 fw-600 ' style={{ fontFamily: 'Poppins' }}>{CUSTOM_MESSAGES().DELETE_LOYALTY_ACCOUNT}</div>
              <div className='d-flex pr-3 position-fixed' style={{ width: '88%', bottom: '4%' }}>
                <TouchableButton type='button' onClick={(event) => { event.preventDefault(); setIsDeleteLoyalty(false) }} className={cn(Style.loyalty_btn, 'col-6 m-1 py-2 rounded border-0  btn-ripple fs-30 fw-600')} style={{ height: '68px' }}>{LABEL().NO}</TouchableButton>
                <TouchableButton type='submit' onClick={(event) => { event.preventDefault(); setIsDeleteLoyalty(false); deleteLoyalty(); }} className={cn('col-6 m-1 py-2 rounded btn-ripple  opacity-75 fs-30 fw-600', Style.coupon_btn)} style={{ background: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }}>{LABEL().DELETE}</TouchableButton>
              </div>
            </div>
          </Modal>
        )}
        {offerSelected && (
          <Modal
            isOpen={offerSelected}
            isModalCenter
            customClass="p-3"
            customClass2='d-flex justify-content-center align-items-center'
            noBackground
            style={{ height: '216px', width: '486px', backgroundColor: serverAppTheme?.popUp_bg, color: serverAppTheme?.primary_text, borderRadius: '16px', boxShadow: serverAppTheme?.popUp_box_shadow, border: serverAppTheme?.popupBorder }}
          >
            <div className={cn('col-12 p-4 row mx-0 justify-content-center align-items-center position-relative text-center')} style={{}}>
              <div className="col-12 fw-400 pb-25">
                <div className='fs_18 text-center' style={{ color: serverAppTheme?.primary_text }}>{CUSTOM_MESSAGES().LOYALTY_SELECT_OFFER}</div>
              </div>
              <div className={cn("col-12 d-flex justify-content-center position-absolute pb-3")} style={{ bottom: '0' }}>
                <div className='col-12 px-0'>
                  <TouchableButton type='submit' onClick={(event) => { event.preventDefault(); setOfferSelected(false); }} className={cn('col-12 px-0 fs_24 fw-600 btn44 od-primary-btn-bg-color od-primary-btn-font-color')} rippleEffect={true}>{LABEL().LOYALTY_CLOSE}</TouchableButton>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};
LoyaltyOffers.propTypes = {
  getLoyaltyOffers: PropTypes.func,
  orderLoyaltyGetOffers: PropTypes.func,
  paymentLoyaltyGetOffers: PropTypes.func,
  accountLookup: PropTypes.func,
  deleteLoyalty: PropTypes.func,
  handleLoyaltyNotNow: PropTypes.func,
  handleApplyOffer: PropTypes.func,
  setErrorPopUp: PropTypes.func,
  loyaltyRes: PropTypes.object,
  loyaltyInfo: PropTypes.object,
  groupedLoyaltyOffer: PropTypes.object,
  offer: PropTypes.object,
  seat: PropTypes.object,
  serverAppTheme: PropTypes.object,
  loyaltyType: PropTypes.number,
  isConfirmStageSplit: PropTypes.bool,
  isLandScape: PropTypes.bool,
  loading: PropTypes.bool,
  showCheckSeat: PropTypes.func,
  storeImage: PropTypes.string,
}
LoyaltyOffers.defaultProps = {
  getLoyaltyOffers: () => {},
  orderLoyaltyGetOffers: () => {},
  paymentLoyaltyGetOffers: () => {},
  accountLookup: () => {},
  deleteLoyalty: () => {},
  handleLoyaltyNotNow: () => {},
  handleApplyOffer: () => {},
  setErrorPopUp: () => {},
  loyaltyRes: {},
  loyaltyInfo: {},
  groupedLoyaltyOffer: {},
  offer: {},
  seat: {},
  serverAppTheme: {},
  loyaltyType: 0,
  isConfirmStageSplit: false,
  isLandScape: false,
  loading: false,
  showCheckSeat: () => {},
  storeImage: '',
};







const mapStateToProps = ({ loyalty }) => ({
  offer: loyalty?.orderLoyaltyOfferData,
  loading: loyalty?.loading,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      orderLoyaltyGetOffers,
      paymentLoyaltyGetOffers,
      setErrorPopUp
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(memo(LoyaltyOffers));

